// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/app.scss
// module id = 952
// module chunks = 8